// BLR (banda laminata = laminated STEEL armour tape) consumption.
// The armouring phase applies TWO overlapping steel tapes helically; the overlap
// factor accounts for the helical lay + edge overlap.
//   kg = wide(mm) × thickness(mm) × density(g/cm³) × length(m) / 1000 × tapes × overlap
// Keep in sync with redis_dev/helpers/blr.js and eng-backend/utils/blr.js.
export const BLR_TAPES = 2;
export const BLR_OVERLAP = 1.15;

const n = v => (Number.isFinite(Number(v)) ? Number(v) : 0);

export function blrKg(wide, thickness, density, length_m) {
  const cs = n(wide) * n(thickness);
  const d = n(density);
  const L = n(length_m);
  if (!cs || !d || !L) return 0;
  return ((cs * d * L) / 1000) * BLR_TAPES * BLR_OVERLAP;
}

// human label from a material row. `grade` carries the spec ("15 x 0.15") and
// survives the execution pipeline (where wide/thickness are dropped).
export function blrLabel(item) {
  if (item?.grade) return `BLR ${item.grade}`;
  const w = item?.wide;
  const t = item?.thickness;
  return w && t ? `BLR ${w} x ${t}` : 'BLR armouring';
}

// treat legacy STEEL rows as BLR too
export function isBlr(material) {
  const m = String(material || '').toUpperCase();
  return m === 'BLR' || m === 'STEEL';
}
